import API from '../utils/api';
import { BACK_OFFICE_API_ENDPOINT } from '../constants/defaultValues';

const getAppVersion = async () => {
    try {
        const res = await API.get(`${BACK_OFFICE_API_ENDPOINT}/versions/cashier`);

        return res.data;
    } catch (error) {
        console.error(error);
        return { info: { success: false } };
    }
};

const AppVersionsService = {
    getAppVersion,
};

export default AppVersionsService;
